// HELPERS DI ORDINAMENTO
export function sortByName<T extends { name?: string }>(list: T[]): T[] {
    return [...list].sort((a, b) => {
        const nameA = (a?.name ?? '').trim();
        const nameB = (b?.name ?? '').trim();

        if (!nameA && !nameB) return 0;

        return nameA.localeCompare(nameB, undefined, { 
        numeric: true, 
        sensitivity: 'base'
        });
    });
}

export function sortByNumericId(list: any[]) {
    return list.sort((a, b) => (Number(a.id) || 0) - (Number(b.id) || 0));
}
//